import { render, staticRenderFns } from "./MatterTypeForm.vue?vue&type=template&id=c0f7ce9c&scoped=true"
import script from "./MatterTypeForm.vue?vue&type=script&lang=js"
export * from "./MatterTypeForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=c0f7ce9c&prod&scoped=true&lang=css&external"
import style1 from "./MatterTypeForm.vue?vue&type=style&index=1&id=c0f7ce9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f7ce9c",
  null
  
)

export default component.exports